<div class="container-status">
    <div class="{{document?.status}}">
      <img alt="{{document?.status}}" />
      <span>{{ document?.envelopeStatus || '--' }}</span>
    </div>
  </div>